import cruzeiroTheme from './cruzeiro.theme';
import ingresseTheme from './ingresse.theme';
import ingressodevantagensTheme from './ingressodevantagens.theme';

const ThemeList = [
  { 1 : ingresseTheme },
  { 7791810 : cruzeiroTheme },
  { 12049153 : ingressodevantagensTheme }
];

export default ThemeList;
